// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__2oy6Z","container":"Button_container__ia_9g","loader":"Button_loader__1Q30F","disabled":"Button_disabled__14K97"};
    if(module.hot) {
      // 1741870133720
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  